import React from 'react';
import isEqual from 'react-fast-compare';

import * as Interfaces from '../../interfaces';
import NavItem, { ComponentProps as NavItemProps } from '../NavItem';
import * as Styled from './styled';

export type ComponentProps = Pick<NavItemProps, 'colorScheme'> & {
  onSelect: (index: number) => void;
  /**
   * the id of the selected navigation option
   */
  activeId?: string;
  /**
   * The items to be displayed in the Column
   */
  items: Interfaces.NavItem[];

  /**
   * The column number the menu is appearing as
   */
  colNum: number;
};

const MenuColumn: React.FC<ComponentProps> = ({
  activeId,
  items = [],
  onSelect,
  colorScheme = Interfaces.MenuColumnTheme.DARK_GREY,
  colNum
}) => {
  const colIsActive: boolean = items.length > 0;
  return (
    <Styled.MenuColumn isActive={colIsActive} colorScheme={colorScheme}>
      {items.map((item, index) => (
        <NavItem
          colNum={colNum}
          rowNum={index}
          key={item.id}
          isActive={activeId === item.id}
          item={item}
          onSelect={() => onSelect(index)}
          colorScheme={colorScheme}
        />
      ))}
    </Styled.MenuColumn>
  );
};

export default React.memo(MenuColumn, (prevProps, nextProps) => {
  return isEqual(prevProps.items, nextProps.items) && prevProps.activeId === nextProps.activeId;
});
